import React, { useEffect, useState } from 'react'
import { Layout } from 'components'
import {
  ProfileImage,
  PersonalInformation,
  ChangePassword,
  BankDetails,
  SubscriptionsAndPurchases, ShippingAddress,
  PaymentMethods,
} from './Sections'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { userBankAccount, userSubscriptions, userPurchases } from 'modules/session/session-actions'
import './index.styl'
import { Menu } from 'antd'

const PAYMENT_METHODS_PATH = '/my-profile/payment-methods'

const MyProfile = () => {
  const { user } = useSelector(state => state.session)
  const dispatch = useDispatch()
  // const [closeBanner, setCloseBanner] = useState(true)
  useEffect(() => {
    window.dataLayer.push({ event: 'Profile' })
  }, [])

  useEffect(() => {
    if (user) {
      dispatch(userBankAccount())
      dispatch(userSubscriptions())
      dispatch(userPurchases())
    }
  }, [])
  // const handleCloseBanner = () => {
  //  setCloseBanner(false)
  // }

  const history = useHistory()
  const { pathname } = useLocation()
  // /my-profile/payment-methods opens the Payment Methods tab (the Sou-Sou site links here)
  const [current, setCurrent] = useState(pathname === PAYMENT_METHODS_PATH ? 'paymentMethods' : 'personal')

  const onClick = e => {
    setCurrent(e.key)
    const target = e.key === 'paymentMethods' ? PAYMENT_METHODS_PATH : '/my-profile'
    if (pathname !== target) history.replace(target)
  }

  const renderContent = () => {
    switch (current) {
      case 'personal':
        return (
          <div>
            <PersonalInformation />
            <ChangePassword />
          </div>)
      case 'subscriptionsAndPurchases':
        return <SubscriptionsAndPurchases />
      case 'bank':
        return <BankDetails />
      case 'paymentMethods':
        return <PaymentMethods />
      case 'address':
        return <ShippingAddress />
      default:
        return <div>Select a menu item to view content</div>
    }
  }
  return (
    <Layout className='wrapperMyProfile'>
      <div className='container'>
        <div className='centered'>
          <div className='mainTitle'>Profile Details</div>
          <div className='grid'>
            <div>
              <ProfileImage />
              {/* {closeBanner ? (
                <div className='wrapperProfileImage'>
                  <img onClick={handleCloseBanner} className='closeBanner' src={CloseBanner} alt='CloseBanner' />
                  <img className='mobileWidth' src={ProfileHelperImage} alt='ProfileHelperImage' />
                  <div className='textHelper'>Add Bank Account information in order to get paid via ACH... OR connect your Stripe Account instead to receive payments </div>
                </div>
              ) : null} */}
            </div>
            <div className='right'>
              <div className='menuProfile'>
                <Menu
                  disabledOverflow
                  onClick={onClick}
                  selectedKeys={[current]}
                  mode='horizontal'
                >
                  <Menu.Item key='personal'>Personal Information</Menu.Item>
                  <Menu.Item key='bank'>Bank Details</Menu.Item>
                  <Menu.Item key='subscriptionsAndPurchases'>Subscriptions and Purchases</Menu.Item>
                  <Menu.Item key='paymentMethods'>Payment Methods</Menu.Item>
                  {/* <Menu.Item key='address'>Shipping Address</Menu.Item> */}
                </Menu>
              </div>
              {renderContent()}

            </div>

            {/* main info */}
            {/* <VenueInformation /> */}
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default MyProfile
